import { DefaultOpportunitiesComponent } from "./components/opportunities/templates/default/default-opportunities.component";
import { SocialOpportunitiesComponent } from "./components/opportunities/templates/social/social-opportunities.component";
import { CieloOpportunitiesComponent } from "./components/opportunities/templates/cielo/cielo-opportunities.component";

export const oppComponentDef = {
    "opportunity-list": {
        "default": DefaultOpportunitiesComponent,
        "social": SocialOpportunitiesComponent,
        "cielo": CieloOpportunitiesComponent
    }
}